const download = {
  download_fields: [
    {
      field: 'about',
      name: 'About',
    },
    {
      field: 'description',
      name: 'Description',
    },
    {
      field: 'subject',
      name: 'Subject',
    },
    {
      field: 'issued',
      name: 'Issued',
    },
  ],
};

export default download;
